<template>
  <div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="是否分配专家" v-show="isShow">
        <el-select
          @clear="expertValueClear"
          clearable
          v-model="expertValue"
          @change="expertValueChange"
        >
          <el-option
            v-for="item in expertOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否审评完成">
        <el-select
          clearable
          @clear="reviewValueClear"
          v-model="reviewValue"
          :disabled="expertValue == 1"
          @change="reviewValueChange"
          placeholder="请先选择专家"
        >
          <el-option
            v-for="item in reviewOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">检索</el-button>
        <el-button type="success" @click="daochu">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :header-cell-style="{ background: '#f8f8f8' }"
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      height="500px"
    >
      <el-table-column
        type="index"
        width="50"
        label="序号"
        align="center"
        :index="indexMethod"
      >
      </el-table-column>
      <el-table-column prop="applyMan" label="填报人" align="center">
      </el-table-column>
      <el-table-column label="填报资料" align="center">
        <template slot-scope="scope">
          <div>
            <el-link type="primary" @click="hrefHanler1(scope.row)">{{
              scope.row.fileName
            }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="填报时间" align="center">
      </el-table-column>
      <el-table-column label="评审专家" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.userNames">
            <el-link
              :disabled="disableUser"
              :type="typeUser"
              @click="hrefHanler(scope.row, index)"
              v-for="(item, index) in scope.row.userNames.split(',')"
              :key="index"
              >{{ item }},</el-link
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="评审意见" align="center">
        <template slot-scope="scope">
          {{
            scope.row.status == 0
              ? "待分配"
              : scope.row.status == 1
              ? "已分配"
              : scope.row.status == 2
              ? "部分评审"
              : scope.row.status == 3
              ? "已返回"
              : scope.row.status == 4
              ? "删除"
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="300" align="center">
        <template v-slot="scope">
          <el-button
            size="mini"
            type="warning"
            v-if="isShow"
            :disabled="scope.row.status == 4"
            @click="del(scope.row)"
            >退回</el-button
          >
          <el-button
            v-if="isShow"
            size="mini"
            type="success"
            :disabled="scope.row.status == 3"
            @click="assignExperts(scope.row)"
            >分配专家</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="reviewBtn(scope.row)"
            :disabled="scope.row.disableBtn"
            v-if="!isShow"
            >审评</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div ref="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="formInline.pageNo"
        :limit.sync="formInline.pageSize"
        @pagination="getList"
      />
    </div>
    <!-- 分配专家 -->
    <el-dialog
      title="分配专家"
      center
      :visible.sync="assignExpertsDialog"
      width="30%"
      :before-close="assignExpertsDialogClose"
      v-if="assignExpertsDialog"
    >
      <div class="expert">
        <span> 资料名称:</span> <span> {{ expertdialogForm.dataName }}</span>
      </div>
      <div class="expert">
        <span> 填报人:</span> <span> {{ expertdialogForm.applyMan }}</span>
      </div>
      <div class="expert">
        <el-form
          :model="expertdialogForm"
          status-icon
          :rules="expertdialogRules"
          ref="expertdialogRef"
          class="demo-ruleForm"
        >
          <el-form-item label="请选择专家:" prop="expert">
            <el-select
              multiple
              filterable
              v-model="expertdialogForm.expert"
              placeholder="请输入专家姓名后选择"
              @change="expertValueDialogChange"
            >
              <el-option
                v-for="item in expertDialogOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignExpertsDialogClose" size="small"
          >返回</el-button
        >
        <el-button type="primary" @click="assignExpertsSubmit" size="small "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 审评 -->
    <el-dialog
      v-if="reviewDialog"
      title="资料评审"
      center
      :visible.sync="reviewDialog"
      width="30%"
      :before-close="reviewDialogDialogClose"
    >
      <div class="expert">
        <span> 资料名称:</span> <span> {{ reviewdialogForm.dataName }}</span>
      </div>
      <div class="expert">
        <span> 资料人:</span> <span> {{ reviewdialogForm.applyMan }}</span>
      </div>
      <div class="expert">
        <span> 填报时间:</span> <span> {{ reviewdialogForm.createTime }}</span>
      </div>
      <div class="expert">
        <span> 填报资料:</span>
        <span>
          <el-link type="primary" @click="hrefHanler1(newReviewdialogForm)">
            {{ reviewdialogForm.fileName }}</el-link
          >
        </span>
      </div>
      <el-form
        :model="reviewdialogForm"
        status-icon
        :rules="reviewdialogRules"
        ref="reviewdialogRef"
        class="demo-ruleForm"
      >
        <el-form-item label="评审得分:" prop="score">
          <el-input
            v-model="reviewdialogForm.score"
            style="width: 30%"
            :disabled="isDisabled1"
          ></el-input>
        </el-form-item>
        <el-form-item label="评审意见:" prop="remark">
          <el-input
            style="width: 80%"
            type="textarea"
            placeholder="请输入内容"
            v-model="reviewdialogForm.remark"
            maxlength="50"
            show-word-limit
            :disabled="isDisabled2"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reviewDialogDialogClose" size="small"
          >返回</el-button
        >
        <el-button type="primary" @click="reviewSubmit" size="small "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getdataReviewItem,
  getSelectByName,
  dataCheckyAdd,
  dataCheckyEdit,
  getDataCheckPage,
  dataCheckyDetail,
  dataReviewItemExport,
  getDataReviewItemDelete,
} from "@/api/api.js";
import axios from "axios";
import baseURL from "@/api/baseUrl.js";
export default {
  name: "",
  data() {
    return {
      disableUser: true,
      typeUser: "primary",
      total: 0,
      loading: false,
      isShow: false,
      expertValue: "",
      expertOptions: [
        {
          label: "是",
          value: 2,
        },
        {
          label: "否",
          value: 1,
        },
      ],
      expertDialogOptions: [],
      reviewValue: "",
      reviewOptions: [
        {
          label: "是",
          value: 2,
        },
        {
          label: "否",
          value: 1,
        },
      ],
      formInline: {
        pageNo: 1,
        pageSize: 10,
        dataId: this.active,
        status: "",
      },
      newReviewdialogForm: {},
      tableData: [],
      assignExpertsDialog: false,
      reviewDialog: false,
      expertdialogForm: {
        expert: "",
        dataName: "",
        applyMan: "",
        pid: "",
        pname: "",
        userName: "",
        userId: "",
      },
      reviewdialogForm: {
        dataName: "",
        applyMan: "",
        createTime: "",
        fileName: "",
        pid: "",
        remark: "",
        score: "",
        userId: "",
      },
      expertdialogRules: {
        // expert: [{ required: true, message: "请选择专家", trigger: "change" }],
      },
      reviewdialogRules: {
        score: [{ required: true, message: "请输入评审得分", trigger: "blur" }],
        remark: [
          { required: true, message: "请输入评审意见", trigger: "blur" },
        ],
      },
      isDisabled1: false,
      isDisabled2: false,
      userName: "admin",
      fpObj: {},
      reviewdialogForm1: {},
    };
  },
  created() {
    this.getList();
    console.log(this.active);
  },
  watch: {},
  mounted() {
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      if (this.userName == user.username) {
        this.isShow = true;
      } else {
        this.expertValue = 2;
        this.isShow = false;
      }
    }
  },
  props: {
    active: {
      type: String,
    },
  },
  methods: {
    daochu() {
      axios({
        method: "get",
        url: baseURL + `/dataReviewItem/export?dataId=${this.active}`,
        headers: { Authorization: "Bearer " + sessionStorage.getItem("token") },
        responseType: "blob",
      }).then((res) => {
        console.log(res);
        const data = res.data;
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: "application/msword",
          })
        );
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", "资料填报审批.xlsx");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },
    hrefHanler1(row) {
      // 在 node.js 用GET请求获取远程图片
      axios({
        method: "get",
        url: baseURL + "/sysFileInfo/download?id=" + row.fileId,
        responseType: "blob",
      }).then((res) => {
        console.log(res);
        const data = res.data;
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: "application/json",
          })
        );
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", row.fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // this.dialogInfo.dialogVisible = false;
      });
    },
    //退回
    del(row) {
      console.log(row);
      this.$confirm("此操作将退回, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var arr = [
          {
            id: row.id,
            dataId: this.active,
          },
        ];
        getDataReviewItemDelete(arr).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
    indexMethod(index) {
      return (
        (this.formInline.pageNo - 1) * this.formInline.pageSize + index + 1
      );
    },
    async getList() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      const res = await getdataReviewItem(this.formInline);
      var tempData = res.data.data.data.rows;
      if (user.account !== "admin") {
        for (let i = 0; i < tempData.length; i++) {
          if (tempData[i].userIds != null && tempData[i].userIds != "") {
            if (tempData[i].userIds.indexOf(user.id) !== -1) {
              tempData[i].disableBtn = false;
            } else {
              tempData[i].disableBtn = true;
            }
          } else {
            tempData[i].disableBtn = true;
          }
        }
      }
      this.tableData = tempData;
      this.total = res.data.data.data.totalRows - 0 || 0;
      if (user.account === "admin") {
        this.disableUser = false;
        this.typeUser = "primary";
      } else {
        this.disableUser = true;
        this.typeUser = "";
      }
    },
    expertValueChange(val) {
      this.expertValue = val;
      this.reviewValue = "";
    },
    expertValueClear() {
      this.expertValue = "";
      this.getList();
    },
    async expertValueDialogChange(val) {
      for (let i = 0; i < val.length; i++) {
        this.fpObj.userId = val[i];
        const res = await getDataCheckPage(this.fpObj);
        if (res.data.data.totalRows > 0) {
          this.$message.error("该专家已经被分配过了");
          this.expertdialogForm.expert = [
            ...val.slice(0, i),
            ...val.slice(i + 1),
          ];
          return;
        }
      }
      this.expertdialogForm.userId = val.join(",");
      let arr = [];
      this.expertDialogOptions.forEach((item) => {
        if (val.includes(item.id)) {
          arr.push(item.name);
        }
      });
      this.expertdialogForm.userName = arr.join(",");
    },
    //分配专家
    async assignExperts(row) {
      this.assignExpertsDialog = true;
      this.fpObj.pId = row.id;
      this.expertdialogForm.applyMan = row.applyMan;
      this.expertdialogForm.dataName = row.dataName;
      this.expertdialogForm.pname = row.dataName;
      this.expertdialogForm.pid = row.id;
      const res = await getSelectByName({ page: 1, pagesize: 20 });
      this.expertDialogOptions = res.data.data.list;
    },
    assignExpertsDialogClose() {
      this.assignExpertsDialog = false;
      this.$refs.expertdialogRef.resetFields();
    },
    assignExpertsSubmit() {
      this.$refs.expertdialogRef.validate(async (valid) => {
        if (valid) {
          var idList = this.expertdialogForm.userId.split(",");
          var nameList = this.expertdialogForm.userName.split(",");
          for (let i = 0; i < idList.length; i++) {
            this.expertdialogForm.userId = idList[i];
            this.expertdialogForm.userName = nameList[i];
            await dataCheckyAdd(this.expertdialogForm);
          }
          this.assignExpertsDialogClose();
          this.$message.success("分配成功");
          this.getList();
        } else {
          return false;
        }
      });
    },

    reviewValueChange(val) {
      this.reviewValue = val;
    },
    reviewValueClear() {
      this.reviewValue = "";
      this.getList();
    },
    search() {
      if (this.expertValue === "" && this.reviewValue === "") {
        this.formInline.status = 0;
      } else if (this.expertValue === 1 && this.reviewValue === "") {
        this.formInline.status = 1;
      } else if (this.expertValue === 2 && this.reviewValue === "") {
        this.formInline.status = 2;
      } else if (this.expertValue === 2 && this.reviewValue === 1) {
        this.formInline.status = 3;
      } else if (this.expertValue === 2 && this.reviewValue === 2) {
        this.formInline.status = 4;
      }
      this.formInline.pageNo = 1;
      this.getList();
    },
    //审评
    async reviewBtn(row) {
      let user = JSON.parse(sessionStorage.getItem("user"));
      this.newReviewdialogForm = { ...row };
      this.reviewDialog = true;
      this.reviewdialogForm.applyMan = row.applyMan;
      this.reviewdialogForm.dataName = row.dataName;
      this.reviewdialogForm.fileName = row.fileName;
      this.reviewdialogForm.createTime = row.createTime;
      this.reviewdialogForm.userId = user.id;
      this.isDisabled1 = false;
      this.isDisabled2 = false;
      var obj = {
        pId: row.id,
        userId: user.id,
      };
      const res = await getDataCheckPage(obj);
      console.log(res);
      if (res.data.data.rows[0].remark !== null) {
        this.reviewdialogForm.score = res.data.data.rows[0].score;
        this.reviewdialogForm.remark = res.data.data.rows[0].remark;
        this.isDisabled1 = true;
        this.isDisabled2 = true;
      }
      this.reviewdialogForm.id = res.data.data.rows[0].id;
      this.reviewdialogForm.pid = res.data.data.rows[0].pid;
    },
    reviewDialogDialogClose() {
      this.reviewDialog = false;
      this.$refs.reviewdialogRef.resetFields();
    },
    reviewSubmit() {
      this.$refs.reviewdialogRef.validate(async (valid) => {
        if (valid) {
          await dataCheckyEdit(this.reviewdialogForm);

          this.getList();
          this.reviewDialogDialogClose();
        } else {
          return false;
        }
      });
    },
    //查看评审
    async hrefHanler(e, index) {
      this.reviewdialogForm.applyMan = e.applyMan;
      this.reviewdialogForm.dataName = e.dataName;
      this.reviewdialogForm.fileName = e.fileName;
      this.reviewdialogForm.createTime = e.createTime;
      this.newReviewdialogForm = { ...e };
      this.isDisabled1 = true;
      this.isDisabled2 = true;
      var obj = {
        pId: e.id,
        userId: e.userIds.split(",")[index],
      };
      const res = await getDataCheckPage(obj);
      var id = res.data.data.rows[0].id;
      let res1 = await dataCheckyDetail(id);
      this.reviewdialogForm.score = res1.data.data.score;
      this.reviewdialogForm.remark = res1.data.data.remark;
      this.reviewDialog = true;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  background: #fff;
  margin: 0;
  padding: 20px;
  box-sizing: border-box;
  min-height: 700px;
  position: relative;
}
::v-deep .pagination-container .el-pagination {
  right: 10px;
  position: absolute;
  bottom: 10px;
}
::v-deep .el-date-editor .el-range-separator {
  padding: 0 !important;
}
.expert {
  margin-bottom: 15px;

  span:nth-child(2) {
    font-weight: 700;
    font-size: 16px;
    margin-left: 5px;
  }
}
</style>
